import { render } from "./AccountOrdersContainer.vue?vue&type=template&id=7d7bcb96"
import script from "./AccountOrdersContainer.vue?vue&type=script&lang=js"
export * from "./AccountOrdersContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__